<template>
  <div class="tree">
    <TreeItem
      v-for="(item, index) in list"
      :data="item"
      :key="index"
      @itemChange="itemChange"
      :checked="selectedMenuList.some((x) => x.id === item.id)"
      :selectedMenuList="selectedMenuList"
    ></TreeItem>
  </div>
</template>

<script>
import TreeItem from './treeItem'
export default {
  components: { TreeItem },
  props: {
    list: {
      type: Array
    },
    selectedMenuList: {
      type: Array
    }
  },
  data() {
    return {}
  },
  methods: {
    itemChange(data) {
      this.$emit('treeChange', data)
    }
  }
}
</script>

<style lang="less" scoped>
.tree {
  padding-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/tree/index.vue